(() => {
  const MODE = "lock"; // "lock" | "hide"

  if (window.__JTL_SAM_GUARD__) return;
  window.__JTL_SAM_GUARD__ = true;

  let observer = null;
  let scheduled = false;

  function getSamWrapper() {
    const drawer = document.querySelector("#CartDrawer");
    return (
      (drawer && drawer.querySelector(".sam__protect--wrapper")) ||
      document.querySelector(".sam__protect--wrapper")
    );
  }

  // Compute eligibility from current cart drawer DOM (updates with AJAX)
  function getEligibilityFromDrawer() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return { eligible: true, blockers: [] };

    const rows = Array.from(drawer.querySelectorAll("tr.cart-item[data-jtl-eligible]"));
    if (!rows.length) return { eligible: true, blockers: [] };

    let eligible = true;
    const blockers = [];

    for (const row of rows) {
      const isService = row.dataset.jtlService === "true";
      if (isService) continue;

      const isEligible = row.dataset.jtlEligible === "true";
      if (!isEligible) {
        eligible = false;
        blockers.push(row.dataset.jtlTitle || "Item");
      }
    }

    return { eligible, blockers };
  }

  function renderLockedDescription(desc, blockers) {
    // Save original HTML once per rendered widget instance
    if (!desc.dataset.originalHtml) {
      desc.dataset.originalHtml = desc.innerHTML;
    }

    desc.innerHTML = "";

    const line = document.createElement("div");
    line.textContent =
      "Order not eligible — item(s) in cart aren’t eligible for Jump the Line.";
    desc.appendChild(line);

    if (blockers.length) {
      const ul = document.createElement("ul");
      ul.className = "jtl-blockers";
      blockers.forEach((title) => {
        const li = document.createElement("li");
        li.textContent = title;
        ul.appendChild(li);
      });
      desc.appendChild(ul);
    }
  }

  function restoreDescription(desc) {
    if (desc?.dataset?.originalHtml) {
      desc.innerHTML = desc.dataset.originalHtml;
    }
  }

  function apply() {
    const wrapper = getSamWrapper();
    if (!wrapper) return;

    const { eligible, blockers } = getEligibilityFromDrawer();
    const checkbox = wrapper.querySelector("#sam_switch_btn");
    const desc = wrapper.querySelector(".sam__widget--description");

    const desiredState = eligible
      ? "eligible"
      : MODE === "hide"
      ? "hidden"
      : "locked";

    const blockersSig = blockers.join("||");

    // Only skip work if BOTH state and blockers list are unchanged
    if (
      wrapper.dataset.jtlState === desiredState &&
      wrapper.dataset.jtlBlockersSig === blockersSig
    ) {
      return;
    }

    wrapper.dataset.jtlState = desiredState;
    wrapper.dataset.jtlBlockersSig = blockersSig;

    wrapper.classList.toggle("jtl-sam-hidden", desiredState === "hidden");
    wrapper.classList.toggle("jtl-sam-locked", desiredState === "locked");

    if (eligible) {
      if (checkbox) checkbox.disabled = false;
      if (desc) restoreDescription(desc);
      return;
    }

    // If ineligible, always force OFF (removes the fee product)
    if (checkbox?.checked && window.__SAM?.widget?.toggleShippingProtection) {
      checkbox.checked = false;
      window.__SAM.widget.toggleShippingProtection(checkbox);
    }

    if (desiredState === "hidden") return;

    // Locked mode
    if (checkbox) checkbox.disabled = true;
    if (desc) renderLockedDescription(desc, blockers);
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;

      if (observer) observer.disconnect();
      try {
        apply();
      } finally {
        const target = document.querySelector("#CartDrawer");
        if (observer && target) observer.observe(target, { childList: true, subtree: true });
      }
    });
  }

  function init() {
    scheduleApply();

    const target = document.querySelector("#CartDrawer");
    if (!target) return;

    observer = new MutationObserver(() => scheduleApply());
    observer.observe(target, { childList: true, subtree: true });

    // Harmless fallback hooks (some themes/apps dispatch these)
    document.addEventListener("cart:refresh", scheduleApply);
    document.addEventListener("cart:updated", scheduleApply);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();